// extracted by mini-css-extract-plugin
export default {"heart":"HeartRating-heart-nZHjG","rating":"HeartRating-rating-sn8Sx"};